import { ref } from 'vue'
import { appkit, lingoMainnet } from '../reown'
import { normalizeEip155ChainId } from './chain-id'

const fallback = normalizeEip155ChainId(lingoMainnet.id) ?? 1

const providerChain = ref(fallback)

appkit.subscribeNetwork((value) => {
  providerChain.value = normalizeEip155ChainId(value.chainId) ?? fallback
})

export const useProviderChain = () => {
  return {
    chainId: providerChain,
  }
}
